/**
 * @generated SignedSource<<425621f9d147f0d2d7a3d702574dfaca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "JwtAuthenticationResponse",
    "kind": "LinkedField",
    "name": "handle",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessToken",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TicketQrsQDownloadMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TicketQrsQDownloadMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "9ad8955f1d1a7f7a162e2ca7655bf8cf",
    "id": null,
    "metadata": {},
    "name": "TicketQrsQDownloadMutation",
    "operationKind": "mutation",
    "text": "mutation TicketQrsQDownloadMutation {\n  handle {\n    accessToken\n  }\n}\n"
  }
};
})();

node.hash = "2c4c82c1daa818f0f42fce2efdde6a24";

module.exports = node;
